import React from 'react'
import Body from './LandingPageCompt/Body/Body'
import { Footer } from './LandingPageCompt/Footer/Footer'
import Header from './LandingPageCompt/Header/Header'


function Beranda() {
  return (
    <>
    <Header />
    <Body />
    <Footer />
    </>
  )
}

export default Beranda